import { cn } from "@/lib/utils";

export type ConnectionStatusBannerTone = "offline" | "reconnecting" | "server";

const TONE_CLASS_NAMES: Record<ConnectionStatusBannerTone, string> = {
  offline: "bg-amber-500 text-amber-950",
  reconnecting: "bg-blue-500 text-white",
  server: "bg-blue-600 text-white",
};

interface ConnectionStatusBannerSurfaceProps {
  icon: React.ReactNode;
  title: string;
  submessage: string;
  tone: ConnectionStatusBannerTone;
  retryCount?: number;
  className?: string;
}

export function ConnectionStatusBannerSurface({
  icon,
  title,
  submessage,
  tone,
  retryCount,
  className,
}: ConnectionStatusBannerSurfaceProps) {
  const showRetryCount = retryCount !== undefined && retryCount > 1;

  return (
    <div
      role="alert"
      aria-live="polite"
      className={cn(
        "fixed top-0 left-0 right-0 z-50",
        "flex flex-col items-center justify-center gap-0.5",
        "py-2 px-4",
        "animate-in slide-in-from-top-2 fade-in duration-300",
        TONE_CLASS_NAMES[tone],
        className
      )}
    >
      <div className="flex items-center gap-2">
        {icon}
        <span className="text-sm font-medium">
          {title}
          {showRetryCount && <span className="ml-1 opacity-80">(attempt {retryCount})</span>}
        </span>
      </div>
      <span className="text-xs opacity-80">{submessage}</span>
    </div>
  );
}
